
<template>
  <div>
    <div>
      <chart></chart>
    </div>
    <div>
      <page-title>Track your practice!</page-title>

      <selectable
        v-for="option in practiceLengths" v-bind:key="option.minutes"
        @click="setOption(option.minutes)"
        >
        {{option.label}}
      </selectable>
      <textarea placeholder="enter notes (optional)" v-mode="notes"></textarea>
      <cta @click="save">Save</cta>
    </div>
    <div>
      <div v-for="session in sessions">
        {{session.minutes}}
      </div>
    </div>
  </div>
</template>


<script>
import Chart from './Chart'
import {
  savePracticeSession,
  getPracticeSessions
} from '../utils/battles-api'



export default {

  data: () => ({
    chart: Chart,
    minutes: 0,
    notes: "",
    practiceLengths: [
      {label: "10 minutes", minutes: 10},
      {label: "20 minutes", minutes: 25},
      {label: "30 minutes", minutes: 30},
      {label: "45 minutes", minutes: 45},
      {label: "1 hour", minutes: 60}
    ],
    sessions: []
  }),
  mounted() {
    getPracticeSessions().then(sessions => {
      console.log(sessions)
      this.sessions = sessions
      alert("gotem")
    }).catch(error => {
      alert("erorr here")
      console.log(error)
    })
  },
  methods: {
    save () {
      alert("hey there")
      savePracticeSession(this.minutes, this.notes).then(sessions => {
        console.log(sessions)
        alert("done")
      }).catch(error => {
        alert("erorr here")
        console.log(error)
      })
    },
    setOption(minutes) {
      this.minutes = minutes
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Practice.vue